module.exports = __webpack_public_path__ + "media/images/content_marketing_star-bd11aab2530fcefe051a896072fa1824.svg";